import { Head } from '@inertiajs/react';
import type { AdminDinnersIndex } from '@/types';
import { DinnerRandomizer } from './components/DinnerRandomizer';

export default function Index({ teams, title }: AdminDinnersIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Dinner</h1>
          <p className="text-muted-foreground">
            Split {teams.length} teams across 3 dinner slots. Mentors stay at
            their tables — their teams rotate.
          </p>
        </div>

        <DinnerRandomizer teams={teams} />
      </div>
    </>
  );
}
